<template>
    <div class="">
        <ServerWillBeOffNotificationModal v-if="displayServerWillBeOffModal"
                                          @closeModal="setServerWillBeOffNoteWasSeen(true)"
        ></ServerWillBeOffNotificationModal>

        <ReloadPageModal v-if="serverWasRestarted"
                         @closeModal="reloadPage"
        ></ReloadPageModal>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import ServerWillBeOffNotificationModal from "./ServerWillBeOffNotificationModal";
    import ReloadPageModal from "./ReloadPageModal";
    
    export default {
        name: "ServerWillBeOffNotification",
        
        components: {
            ReloadPageModal,
            ServerWillBeOffNotificationModal
        },

        data() {
            return {
                serverWillBeOffNotificationWasSeen: false,
            }
        },
        
        computed: {
            ...mapState('sockets', [
                'serverWillBeOff',
                'serverWillBeOffNoteWasSeen',
                'serverWasRestarted',
            ]),

            displayServerWillBeOffModal() {
                return this.serverWillBeOff && !this.serverWillBeOffNoteWasSeen && !this.serverWasRestarted;
            },
            
        },
        
        methods: {
            ...mapMutations('sockets', [
                'setServerWillBeOffNoteWasSeen',
            ]),

            reloadPage() {
                // reload the page to get the updated files from the server
                location.reload();
            },

        },
        
    }
</script>

<style>

</style>